export default __webpack_public_path__ + "static/media/Red Circle.835dc411.svg";